import axios from "axios";
import axiosInstance from "../../axios";
import { ADD_ADDRESS, GET_ALL_ADDRESS, UPDATE_PROFILE_DATA, UPDATE_ADDRESS, DELETE_ADDRESS, FORGOT_PASSWORD, SINGLE_USER } from "../types";
import Swal from "sweetalert2";

// const userAuth = localStorage.get('auth')
// console.log(userAuth,'fffaaa')

export const updateProfile = (formData, addressType) => async (dispatch) => {
    try {
        const bodyFormData = new FormData();

        // Append only the necessary fields based on the selected address type
        bodyFormData.append("id", formData.id);
        bodyFormData.append(addressType, formData[addressType]); // Either "homeAddress" or "officeAddress"

        const res = await axiosInstance.post("/userprofile/update", bodyFormData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        if (res.data.code === 1) {
            Swal.fire({
                title: "Good job!",
                text: `${addressType === 'homeAddress' ? 'Home' : 'Office'} Address Updated Successfully`,
                icon: "success"
            });
            dispatch({ type: UPDATE_PROFILE_DATA, payload: res.data.data });
        }
    } catch (err) {
        console.error("Failed to update profile:", err.message);
    }
};
export const AddAddress = (formData) => async (dispatch) => {
    try {


        const res = await axiosInstance.post("/user/address", formData);

        if (res.data.code === 1) {
            Swal.fire({
                title: "Success",
                text: `New Address Added Successfully`,
                icon: "success"
            });
            dispatch({ type: ADD_ADDRESS, payload: res.data.data });
        }
    } catch (err) {
        console.error("Failed to update profile:", err.message);
    }
};
export const GetAllAddress = () => async (dispatch) => {
    try {
        const res = await axiosInstance.get("/user/addresses");
        if (res.data.code === 1) {
            dispatch({ type: GET_ALL_ADDRESS, payload: res.data.data });
        }
    } catch (err) {
        console.error("Failed to update profile:", err.message);
    }
};
export const GetSingleUser = (params) => async (dispatch) => {
    const { _id } = params
    try {
        const res = await axiosInstance.get(`/user/${_id}`);
        if (res.data.code === 1) {
            dispatch({
                type: SINGLE_USER
                , payload: res.data.data
            });
        }
    } catch (err) {
        console.error("Failed to update profile:", err.message);
    }
};


export const UpdateAddress = (formData) => async (dispatch) => {
    try {
        console.log("formData ===========:", formData)
        const res = await axiosInstance.put(`/user/address/${formData.id}`, formData);
        if (res.data.code === 1) {
            Swal.fire({
                title: "Success",
                text: `Address Updated Successfully`,
                icon: "success"
            });
            dispatch({ type: UPDATE_ADDRESS, payload: res.data.data });
        }
    } catch (err) {
        console.error("Failed to update profile:", err.message);
    }
};
export const DeleteAddress = (params) => async (dispatch) => {
    try {
        const res = await axiosInstance.delete(`/user/address/${params}`);
        if (res.data) {
            Swal.fire({
                title: "Success",
                text: "Address Deleted Successfully",
                icon: "success",
            });
            dispatch({ type: DELETE_ADDRESS, payload: res.data.data });
        } else {
            Swal.fire({
                title: "Failed",
                text: res.data.message || "Could not delete the address.",
                icon: "error",
            });
        }
    } catch (err) {
        console.error("Failed to delete address:", err.message);
        Swal.fire({
            title: "Error",
            text: "Something went wrong while deleting the address.",
            icon: "error",
        });
    }
};

export const Handle_Forgot_Password = (params) => async (dispatch) => {
    try {
        const res = await axiosInstance.post(`/forgot-password`, params);
        if (res.data) {
            Swal.fire({
                title: "Success",
                text: "OTP has been Sent Successfully",
                icon: "success",
            });
            dispatch({ type: FORGOT_PASSWORD, payload: res.data.data });
        } else {
            Swal.fire({
                title: "Failed",
                text: res.data.message || "Could not send the otp.",
                icon: "error",
            });
        }
    } catch (err) {
        console.error("Failed to delete address:", err.message);
        Swal.fire({
            title: "Error",
            text: "Something went wrong while senting the otp.",
            icon: "error",
        });
    }
};
export const Handle_Reset_Password = (params) => async (dispatch) => {
    try {
        const res = await axiosInstance.post(`/reset-password`, params);
        if (res.data) {
            Swal.fire({
                title: "Success",
                text: "Password has been Changed Successfully",
                icon: "success",
            });
            dispatch({ type: FORGOT_PASSWORD, payload: res.data.data });
        } else {
            Swal.fire({
                title: "Failed",
                text: res.data.message || "Could not change password.",
                icon: "error",
            });
        }
    } catch (err) {
        console.error("Failed to delete address:", err.message);
        Swal.fire({
            title: "Error",
            text: "Something went wrong while changing the password.",
            icon: "error",
        });
    }
};